import type { RequestState } from '../types';

export const SET_PAGE = 'SET_PAGE';
export const SET_COUNTRY_OPTIONS = 'SET_COUNTRY_OPTIONS';
export const SET_REGION_OPTIONS = 'SET_REGION_OPTIONS';
export const SET_CITY_OPTIONS = 'SET_CITY_OPTIONS';
export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_REGION = 'SET_REGION';
export const SET_CITY = 'SET_CITY';
export const SET_ARRIVAL = 'SET_ARRIVAL';
export const SET_DURATION = 'SET_DURATION';
export const SET_OCCUPANCY = 'SET_OCCUPANCY';
export const SET_FILTER_SET = 'SET_FILTER_SET';
export const RESET_FILTER_SET = 'RESET_FILTER_SET';

export interface ActionSetPage {
  type: typeof SET_PAGE;
  page: number;
}

export interface ActionSetCountryOptions {
  type: typeof SET_COUNTRY_OPTIONS;
  countries: string[];
}

export interface ActionSetRegionOptions {
  type: typeof SET_REGION_OPTIONS;
  regions: string[];
}

export interface ActionSetCityOptions {
  type: typeof SET_CITY_OPTIONS;
  cities: string[];
}

export interface ActionSetCountry {
  type: typeof SET_COUNTRY;
  countryCode: string;
}

export interface ActionSetRegion {
  type: typeof SET_REGION;
  countryCode: string;
  region: string;
}

export interface ActionSetCity {
  type: typeof SET_CITY;
  countryCode: string;
  region: string;
  city: string;
}

export interface ActionSetArrival {
  type: typeof SET_ARRIVAL;
  arrival: moment.Moment | null;
}

export interface ActionSetDuration {
  type: typeof SET_DURATION;
  durationOfStay: number | null;
}

export interface ActionSetOccupancy {
  type: typeof SET_OCCUPANCY;
  occupancy: number;
}

export interface ActionSetFilterSet {
  type: typeof SET_FILTER_SET;
  filterSet: Partial<RequestState['filterSet']>;
}

export interface ActionResetFilterSet {
  type: typeof RESET_FILTER_SET;
}

export type RequestActions =
  | ActionSetPage
  | ActionSetCountryOptions
  | ActionSetRegionOptions
  | ActionSetCityOptions
  | ActionSetCountry
  | ActionSetRegion
  | ActionSetCity
  | ActionSetArrival
  | ActionSetDuration
  | ActionSetOccupancy
  | ActionSetFilterSet
  | ActionResetFilterSet;

export default {
  SET_PAGE,
  SET_COUNTRY_OPTIONS,
  SET_REGION_OPTIONS,
  SET_CITY_OPTIONS,
  SET_COUNTRY,
  SET_REGION,
  SET_CITY,
  SET_ARRIVAL,
  SET_DURATION,
  SET_OCCUPANCY,
  SET_FILTER_SET,
  RESET_FILTER_SET,
};
